/** Texts that the API builds in Russian and the cabinet shows as they arrive (alerts, pilot notices, email archetypes). */
export default {
  en: {
    'Связь с провайдером оборвалась во время передачи. Автоматически такие письма не повторяются, чтобы не прислать дубль.':
      'The connection to the provider dropped during handoff. Such emails are not retried automatically, so that no duplicate is sent.',
    'Ответы собраны правилами; решения о запуске принимает человек.': 'Replies were assembled by rules; a person makes the launch decisions.',
    'Вы общаетесь с AI-ассистентом; решения о запуске принимает человек.': 'You are talking to the AI assistant; a person makes the launch decisions.',
    'Код подтверждения (2FA)': 'Verification code (2FA)',
    'Чек об оплате': 'Payment receipt',
    'Приветствие после регистрации': 'Welcome after sign-up',
    'Приглашение в команду': 'Team invitation',
    'Вход по ссылке': 'Magic sign-in link',
  },
  uk: {
    'Связь с провайдером оборвалась во время передачи. Автоматически такие письма не повторяются, чтобы не прислать дубль.':
      'Зв’язок із провайдером перервався під час передачі. Такі листи автоматично не повторюються, щоб не надіслати дубль.',
    'Ответы собраны правилами; решения о запуске принимает человек.': 'Відповіді складено за правилами; рішення про запуск ухвалює людина.',
    'Вы общаетесь с AI-ассистентом; решения о запуске принимает человек.': 'Ви спілкуєтеся з AI-асистентом; рішення про запуск ухвалює людина.',
    'Код подтверждения (2FA)': 'Код підтвердження (2FA)',
    'Чек об оплате': 'Чек про оплату',
    'Приветствие после регистрации': 'Привітання після реєстрації',
    'Приглашение в команду': 'Запрошення до команди',
    'Вход по ссылке': 'Вхід за посиланням',
  },
};
